import React, { useState, useEffect } from 'react';
import { practitionersAPI } from '../../services/api';
import './PractitionerSelector.scss';

const PractitionerSelector = ({ onPractitionerSelect, selectedPractitioner, selectedLocation }) => {
  const [practitioners, setPractitioners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchPractitioners();
  }, [selectedLocation]);

  const fetchPractitioners = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await practitionersAPI.getAll();
      let allPractitioners = response.data || [];
      // Filter by selected location if available
      if (selectedLocation) {
        allPractitioners = allPractitioners.filter((practitioner) => {
          if (!practitioner.locations || practitioner.locations.length === 0) return true;
          return practitioner.locations.some(
            (loc) => (loc._id || loc) === selectedLocation._id
          );
        });
      }
      setPractitioners(allPractitioners);
    } catch (err) {
      setError('Failed to load practitioners');
      console.error('Error fetching practitioners:', err);
    } finally {
      setLoading(false);
    }
  };

  const handlePractitionerClick = (practitioner) => {
    onPractitionerSelect(practitioner);
  };

  const handleAnyPractitioner = () => {
    onPractitionerSelect(null);
  };

  if (loading) {
    return (
      <div className="practitioner-selector">
        <div className="loading-state">Loading practitioners...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="practitioner-selector">
        <div className="error-state">{error}</div>
      </div>
    );
  }

  return (
    <div className="practitioner-selector">
      <h2>Select a Practitioner</h2>
      <p className="subtitle">Choose your preferred therapist or select any available practitioner</p>
      
      <div className="practitioners-container">
        <div
          className={`practitioner-card any-practitioner ${!selectedPractitioner ? 'selected' : ''}`}
          onClick={handleAnyPractitioner}
        >
          <div className="practitioner-content">
            <div className="practitioner-header">
              <h3>Any Practitioner</h3>
            </div>
            <p className="practitioner-description">
              Let us assign the best available practitioner for your appointment
            </p>
          </div>
          <div className="practitioner-footer">
            <span className="select-indicator">
              {!selectedPractitioner ? '✓ Selected' : 'Select'}
            </span>
          </div>
        </div>

        <div className="practitioners-grid">
          {practitioners.map((practitioner) => (
            <div
              key={practitioner._id}
              className={`practitioner-card ${selectedPractitioner?._id === practitioner._id ? 'selected' : ''}`}
              onClick={() => handlePractitionerClick(practitioner)}
            >
              {practitioner.image && (
                <div className="practitioner-image">
                  <img src={practitioner.image} alt={practitioner.name} />
                </div>
              )}
              <div className="practitioner-content">
                <div className="practitioner-header">
                  <h3>{practitioner.name}</h3>
                </div>
                {practitioner.role && (
                  <p className="practitioner-role">{practitioner.role}</p>
                )}
                {practitioner.qualifications && (
                  <p className="practitioner-qualifications">{practitioner.qualifications}</p>
                )}
                {practitioner.bio && (
                  <p className="practitioner-bio">{practitioner.bio}</p>
                )}
              </div>
              <div className="practitioner-footer">
                <span className="select-indicator">
                  {selectedPractitioner?._id === practitioner._id ? '✓ Selected' : 'Select'}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PractitionerSelector;
